import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "aes",
  extensions: [".aes"],
  aliases: ["aes", "sophia", "Sophia"],
  loader: () => import('./sophia.js')
});
